<div class="table table-desktop" *ngIf="!isViewMobile else elseBlock">
    <app-comercial class="table"(actionEraser)="emitAction($event)" [orders]="orders"></app-comercial> <!-- *ngIf="isComercial"  -->
</div>

<ng-template #elseBlock>
    <div class="price-mobile" *ngFor="let order of orders | matchOrdersByName: -1:orderFilter">
        <app-table-mobile-order class="info-product" [orders]="order"></app-table-mobile-order>
    </div>
</ng-template>
